import { toast } from 'react-toastify';

export function savedToast(entityName) {
  const label = String(entityName || 'Item').trim();
  toast.success(`${label} has been saved`, {
    icon: '✅',
  });
}

export function errorToast(message = 'Error, unable to save changes') {
  toast.error(message, {
    icon: '❌',
  });
}

export function warnToast(message) {
  toast.warn(message, {
    icon: '⚠️',
  });
}

export function deletedToast(entityName) {
  const label = String(entityName || 'Item').trim();
  toast.success(`${label} Entry has been deleted`, {
    icon: '🗑️',
  });
}


